<template>
  <div
    class="drag__wrapper"
    ref="dragRef"
    :style="{top:pos.y+'px', left:pos.x+'px'}"
    @mousemove="onTouchMove"
    @touchmove.stop="onTouchMove"
  >
    <slot/>
  </div>
</template>

<script>
  export default {
    props: {
		// 修改默认值 2022年7月15日byzb
      position: {
        type: Object,
        default: () => ({
          x: 0,
          y: 0,
        }),
      },
	  isFixedLeft:{
		  type:Boolean,
		  default:false
	  }
    },
    data() {
      return {
        flags: false,
        pos: {
          x: 0,
          y: 0,
        },
      };
    },
    mounted() {
      // 获取容器元素的尺寸信息
      const rect = this.$refs.dragRef.getBoundingClientRect();
      // 获取容器元素尺寸的一半便于后面计算使用
      this.wrapperHalfWidth = rect.width / 2;
      this.wrapperHalfHeight = rect.height / 2;
      // 获取屏幕的尺寸信息
      const clientWidth =
        document.body.clientWidth || document.documentElement.clientWidth;
      const clientHeight =
        document.body.clientHeight || document.documentElement.clientHeight;
      // 获取拖拽元素在屏幕内可拖拽的边界值
      this.maxX = clientWidth - rect.width;
      this.maxY = clientHeight - rect.height;
		
		// 设置默认值
		if(this.$props.position.x || this.$props.position.y){
				 this.pos = {...this.$props.position}; 
		}else{
			this.pos = {
			  x: clientWidth - 50,
			  y: 5,
			};
		}
    },
    methods: {
      onTouchMove(event) {
        // 获取触点，兼容PC和移动端
        let touch;
        if (event.touches) {
          touch = event.touches[0];
        } else {
          touch = event;
        }
        // 定位滑块的位置
        this.pos.x = touch.clientX - this.wrapperHalfWidth;
        this.pos.y = touch.clientY - this.wrapperHalfHeight;
        // 处理边界
        if (this.pos.x < 0) {
          this.pos.x = 0;
        } else if (this.pos.x > this.maxX) {
          this.pos.x = this.maxX;
        }
        if (this.pos.y < 0) {
          this.pos.y = 0;
        } else if (this.pos.y > this.maxY) {
          this.pos.y = this.maxY;
        }
		if(this.isFixedLeft){
			this.pos.x = 0;
		}
        // 阻止页面的滑动默认事件
        event.preventDefault();
      },
    },
  };
</script>

<style lang="less">
  .drag__wrapper {
    position: fixed;
    z-index: 10;


    .box {
      width: 40px;
      height: 40px;
      background: #ffffff;
      border-radius: 50%;
      text-align: center;
      line-height: 40px;
      color: #4A66FA;
      font-size: 13px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .3);
    }
  }
</style>
